var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipCheckbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.52344H3C2.44667 2.52344 2 2.9701 2 3.52344V13.5234C2 14.0768 2.44667 14.5234 3 14.5234H13C13.5533 14.5234 14 14.0768 14 13.5234V3.52344C14 2.9701 13.5533 2.52344 13 2.52344ZM13 13.5234H3V3.52344H13V13.5234Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.81677L10.7067 6.02344L7 9.69677L5.29333 8.02344L4.5 8.79677L7 11.2701L11.5 6.81677Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipCheckbox);
export default __webpack_public_path__ + "static/media/ic-chip-checkbox.a6249d3fd49474dcb42ef77e346a72b3.svg";
export { ForwardRef as ReactComponent };